import Swiper from 'swiper';

export function diplomasSlider() {

    let slider = document.querySelector('.diplomas-slider'),
        sliderWrapper = document.querySelector('.diplomas-slider__wrapper'),
        sliedesLength = document.querySelectorAll('.diplomas-slide').length,
        sliderDiplomas;

    if (!slider) {
        return false;
    }

    const initSlider = () => {

        if ((window.innerWidth > 767 && sliedesLength <= 4) || sliedesLength == 1) {
            slider.classList.add('is-disabled');

            if (sliderDiplomas) {
                sliderDiplomas.destroy();
                sliderWrapper.style.transform = '';
            }

            return false;
        }

        slider.classList.remove('is-disabled');

        sliderDiplomas = new Swiper('.diplomas-slider', {
            containerModifierClass: 'diplomas-slider',
            wrapperClass: 'diplomas-slider__wrapper',
            slideClass: 'diplomas-slide',
            slideActiveClass: 'is-active',
            breakpoints: {
                1319: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                },
                999: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                },
                767: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    centeredSlides: true,
                },
            },
            pagination: {
                el: '.diplomas-slider__pagination',
                type: 'bullets',
                bulletClass: 'diplomas-slider__bullet',
                bulletActiveClass: 'diplomas-slider__bullet_active',
                clickable: true,
            },
            navigation: {
                nextEl: '.diplomas-button-next',
                prevEl: '.diplomas-button-prev',
            },
        });
    }

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( item => {
            window.addEventListener(item, script);
        });
    }

    adaptive(initSlider);

}